﻿import { createRoot } from "react-dom/client";
import { configureMobX } from "../shared-components/configuration/ConfigureMobx";
import { throwError } from "../util/assertions/throwError";
import { Fetcher } from "../util/io/Fetcher";
import { AppStoresFactory } from "../shared-components/AppStoresFactory";
import { LayoutViewModelModel } from "../../OpenApi/api";
import React from "react";
import { Provider } from "mobx-react";
import { DobAssetsProvider } from "@dedalusdiit/dob-components";
import { AboutUsContentComponent } from "../shared-components/header/help-menu/about-us/AboutUsContentComponent";
import { OopsPageErrorCatchingComponent } from "../shared-components/error-catching-component/OopsPageErrorCatchingComponent";
import { redirectIfEolBrowser } from "../shared-components/configuration/EolBrowserGuard";
import { InitialResourcesLoader } from "../resources/InitialResourcesLoader";

/**
 * This is done from within POW3
 */
async function initializeAboutUs(): Promise<void> {
    if (redirectIfEolBrowser(window)) {
        return;
    }
    const appHtmlRoot = document.getElementById("about-us-dialog-content") ?? throwError("❌ No 'about-us-dialog-content' html root found. This is weird.");
    const root = createRoot(appHtmlRoot);

    try {
        const fetcher = new Fetcher();
        const appStoresFactory = new AppStoresFactory(fetcher, window);
        const viewModel: LayoutViewModelModel = await fetcher.getJSON<LayoutViewModelModel>("/POW4/layout-view-model");
        const initialResourcesLoader = InitialResourcesLoader.start(fetcher, `/POW4/resources?v=${viewModel.productInfo.version}`);
        const appStores = await appStoresFactory.create(viewModel, initialResourcesLoader);

        root.render(
            <OopsPageErrorCatchingComponent isLandingPage={false}>
                <Provider {...appStores}>
                    <DobAssetsProvider path={"/POW4/dob-assets/"}>
                        <AboutUsContentComponent />
                    </DobAssetsProvider>
                </Provider>
            </OopsPageErrorCatchingComponent>,
        );
    } catch (error) {
        root.render(<OopsPageErrorCatchingComponent error={error} isLandingPage={false} />);
    }
}

function configureAboutUs() {
    configureMobX();
}

window["configureAboutUs"] = configureAboutUs;
window["initializeAboutUs"] = initializeAboutUs;
